import { FC, useMemo } from 'react'
import { FilterCriteriaValueFieldProps } from './FilterCriteriaValueFieldProps'
import { DatePicker } from '@mui/x-date-pickers'
import { LocalDate } from '@js-joda/core'
import { fromNativeDate, toNativeDate } from '@portal/pkg-format/date'

export const FilterCriteriaValueDate: FC<FilterCriteriaValueFieldProps> = ({
  fieldProps: { value, onChange, onBlur, error, ...fieldProps },
}) => {
  const calculatedValue = useMemo(() => {
    try {
      return toNativeDate(LocalDate.parse(value))
    } catch {
      return null
    }
  }, [value])

  const handleChange = (value: Date | null) => {
    if (value) {
      onChange(fromNativeDate(value).toString())
    } else {
      onChange('')
    }
  }

  return (
    <DatePicker
      slotProps={{
        textField: {
          size: 'small',
          fullWidth: true,
          onBlur,
          error,
          sx: { '& .MuiPickersSectionList-root': { width: '100%' } },
        },
      }}
      value={calculatedValue}
      onChange={handleChange}
      {...fieldProps}
    />
  )
}
